<template>
  <div>
    <v-select
      v-if="schools.length > 0"
      :items="schools"
      label="Switch School"
      v-model="selectedSchoolEmis"
      item-text="schname"
      item-value="emis"
      @change="getSelectedSchool()"
    ></v-select>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: ["userId"],
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    },
  },
  data: () => ({
    schools: [],
    selectedSchoolEmis: "",
  }),
  mounted() {
    if (this.itsBitsems) {
      axios.getData("/get-all-schools").then((schools) => {
        this.schools = schools.sort();
      });
    } else {
      axios
        .postDataWithToken(
          "/auth/get-user-schools-with-access",
          { userId: this.userId },
          this.getAccessToken
        )
        .then((schools) => {
          this.schools = schools.sort();
        });
    }
  },
  methods: {
    getSelectedSchool() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-selected-school",
          { emis: this.selectedSchoolEmis },
          this.getAccessToken
        )
        .then((data) => {
          this.$store.commit("setUserSchool", data.school);
          this.$store.commit("setThemeColor", data.school.primary_bg_color);
          this.$store.commit(
            "setSecondaryColor",
            data.school.secondary_bg_color
          );
          this.$store.commit("setAppName", data.school.schname);
          this.$store.commit("setSiteArticles", data.posts);
          this.$store.commit("setSiteStats", data.stats);
          this.$store.commit("setCurrentUser", data.user);
          this.$store.commit("setAllStudents", []);
          this.$store.dispatch("setUserStudents", {
            userId: this.userId,
            token: this.getAccessToken,
          });

          localStorage.setItem("themeColor", data.school.primary_bg_color);
          localStorage.setItem(
            "secondaryColor",
            data.school.secondary_bg_color
          );
          localStorage.setItem("appName", data.school.schname);
          localStorage.setItem("userSchool", JSON.stringify(data.school));
          this.$emit("school-switched", data);
          this.$store.commit("setLoader", false);
          this.$router.push("/switchboard");
        });
    },
  },
};
</script>

<style></style>
